import $ from "jquery";
import React, {useEffect, useState} from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "../../styles/css/admin-style.css"
import {userService} from "../../services/userService";
import FormControl from "../../shared/components/FormControl";

export interface UserInfo {
    email: string;
    firstName: string,
    lastName: string,
    inactive: boolean,
    userId: string
}

interface EditUserModalProps {
    show: boolean;
    toggle: () => void;
    user: UserInfo;
    refreshData: () => void;
}

const EditUserModal: React.FC<EditUserModalProps> = ({ show, toggle, user, refreshData}) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [userId, setUserId] = useState("")
    const [showErrors, setShowErrors] = useState(false);

    const handleSave = () => {
        if (!firstName || !lastName || !email) {
            setShowErrors(true);
            return;
        }
        Promise.resolve(
            userService.updateUser(userId, firstName, lastName, email, !isActive)
        ).then(postRes => {
            if(postRes === undefined)
                return;
            refreshData();
            toggle();
            return postRes;
        });
        
    };

    useEffect(() => {
        if(!user) return;
        setUserId(user.userId)
        setFirstName(user.firstName)
        setLastName(user.lastName)
        setEmail(user.email)
        setIsActive(!user.inactive)
    }, [user]);

    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">Admin</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="userFirstName" className="col-md-6 mb-3">
                            <FormControl
                                showErrors={showErrors}
                                type="text"
                                label="First Name"
                                placeholder="First Name"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="userLastName" className="col-md-6 mb-3">
                            <FormControl
                                label="Last Name"
                                showErrors={showErrors}
                                type="text"
                                placeholder="Last Name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="userEmail" className="mb-3">
                            <FormControl
                                type="email"
                                label={"Email Address"}
                                placeholder="Email Address"
                                value={email}
                                showErrors={showErrors}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="userStatus" className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Check
                                type="switch"
                                label={isActive ? "Active" : "Inactive"}
                                checked={isActive}
                                onChange={() => setIsActive(!isActive)}
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default EditUserModal;


